var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full"},[_c('div',{ref:"pw-0",staticClass:"inner-wrapper relative h-[calc(100vh-60px)] flex items-center"},[_vm._m(0)]),_c('div',{staticClass:"audio border-t border-black"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm:w-full flex items-start justify-center sm:order-last -order-1"},[_c('div',{staticClass:"w-full",attrs:{"id":"player"}})])
}]

export { render, staticRenderFns }